"use strict";

angular.module("internal.exams").controller("InternalExamSessionsList", [
    "$scope",
    "EXSessions",
    function ($scope, EXSessions) {
        EXSessions.get().then(function (Sessions) {
            $scope.Sessions = Sessions.records;
            $scope.Sessions.forEach(function (session) {
                session.coordinatorUsersList = '';
                session.examinerUsersList = '';
                session.candidateUsersList = '';
                session.candidateCertsList = '';
                session.coordinatorUsers.forEach(function (coordinatorUser) {
                    session.coordinatorUsersList += coordinatorUser.id + ',';
                });
                session.examinerUsers.forEach(function (examinerUser) {
                    session.examinerUsersList += examinerUser.id + ',';
                });
                session.candidateUsers.forEach(function (candidateUser) {
                    session.candidateUsersList += candidateUser.fullName + ',';
                    if (!isUndefined(candidateUser.certificationId)) {
                        session.candidateCertsList += candidateUser.certificationId + ',';
                    }
                });
            });
            $scope.loading = false;
        });
    }
]);
